'use strict';

var urlUtilities = require('../utilities/urlUtilities');
var handleADA = require('../common/handleADA');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data('url');
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: 'GET',
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Remove class show if clicked outside
 *
 * @param {string} selector - Element to check
 * @param {string} elementClass - Element to remove class
 * @param {string} className - Class to add/remove
 * @return {undefined}
 */
function clickOutside(selector, elementClass, className) {
    var removeClickListener;
    var outsideClickListener = function (event) {
        var $target = $(event.target);
        if ($(elementClass).hasClass(className) && !$(selector).has($target).length > 0) {
            $(elementClass).removeClass(className);
            removeClickListener();
        }
    };

    removeClickListener = function () {
        $(document).off('click', outsideClickListener);
    };

    $(document).on('click', outsideClickListener);
}

/** Show and hide active filters */
function showFilter() {
    $('.refinement .card-header .title').on('click',
        function (e) {
            if (($('.refinement.active') && !$('.refinement.active').is($(e.target).closest('.refinement'))) || $('#sort-by-container').hasClass('show')) {
                $('body').click();
            }
            var innerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            e.stopPropagation();
            if (innerWidth < 992) {
                $(e.target).closest('.refinement').toggleClass('active');
            } else if ($(e.target).closest('.refinement').hasClass('active')) {
                $('body').click();
            } else {
                $(e.target).closest('.refinement').addClass('active');
                clickOutside('.refinement .card-body', '.refinement', 'active');
            }
        }
    );
    if ($('.filters-container').hasClass('show') && !$('.filter-results').hasClass('show')) {
        $('.filter-results').addClass('show');
    }
}

/** Show and hide sort dropdown */
function showSortOrder() {
    $('.dropdown-container #sort-order-by-button').on('click',
        function (e) {
            if ($('.refinement.active').length > 0) {
                $('body').click();
            }
            if (!$('#sort-by-container').hasClass('show')) {
                e.stopPropagation();
                $('#sort-by-container').addClass('show');
                clickOutside('#sort-order-list', '#sort-by-container', 'show');
            }
        }
    );
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Set filters and breadcrumbs fixed if the scroll is not up
 */
function fixHeader() {
    var innerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if ($(window).scrollTop() >= 30 && innerWidth > 991) {
        $('.search-results .breadcrumb').addClass('fixed-top');
        $('.search-results .filter-bar').addClass('fixed-top');
        $('.search-results .refinement-bar').addClass('fixed-top');
        $('.search-results .grid-header').addClass('fixed-top');
        $('.search-results .product-grid').addClass('margin-fixed');
    } else {
        $('.search-results .breadcrumb').removeClass('fixed-top');
        $('.search-results .filter-bar').removeClass('fixed-top');
        $('.search-results .refinement-bar').removeClass('fixed-top');
        $('.search-results .grid-header').removeClass('fixed-top');
        $('.search-results .product-grid').removeClass('margin-fixed');
    }
}

module.exports = {
    pressEnterInPLPListItem: handleADA.pressEnterToNavigateUsingAInsideElement('.product-grid', '#product-list-tile', '.link'),
    focusNextElementOutsideSortContainerWhenPressTab: handleADA.focusNextElementOutsidefromSortOrderContainerWhenPressTab(),
    sortOptionsPressEnterBestMatches: handleADA.pressEnterItem('.best-matches'),
    sortOptionsPressEnterPriceLowToHigh: handleADA.pressEnterItem('.price-low-to-high'),
    sortOptionsPressEnterPriceHighToLow: handleADA.pressEnterItem('.price-high-to-low'),
    sortOptionsPressEnterProductAToZ: handleADA.pressEnterItem('.product-name-ascending'),
    sortOptionsPressEnterProductZToA: handleADA.pressEnterItem('.product-name-descending'),
    sortOptionsPressEnterBrand: handleADA.pressEnterItem('.brand'),
    sortOptionsPressEnterMostPopular: handleADA.pressEnterItem('.most-popular'),
    sortOptionsPressEnterTopSellers: handleADA.pressEnterItem('.top-sellers'),
    removeAnimation: function () {
        if (window.location.search.indexOf('?sz=') > -1) {
            $('.product').addClass('no-animation');
        }
    },
    showFilters: showFilter(),
    showSortDropdown: showSortOrder(),
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $('.container').on('click', 'button.filter-results', function () {
            var innerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (innerWidth < 992) {
                if (!$('.refinement-bar').hasClass('show')) {
                    $('.refinement-bar').addClass('show');
                    $('button.filter-results').addClass('show');
                    $('.refinement-size').addClass('active');
                    $('.refinement-size').slideDown();
                }
                $('.refinement-bar').siblings().attr('aria-hidden', true);
                $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
                $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
                $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
                $('.refinement-bar .close').focus();
            }
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $('.container').on('click', '.refinement-bar button.close', function () {
            if ($('.refinement-bar').hasClass('show')) {
                $('.refinement-bar').removeClass('show');
                $('button.filter-results').removeClass('show');
            }
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $('.filter-header button.close').on('click', function () {
            if ($('.refinement-bar').hasClass('show')) {
                $('.refinement-bar').removeClass('show');
                $('button.filter-results').removeClass('show');
            }
            if ($('.refinement.active')) {
                $('.refinement.active').removeClass('active');
            }
            $('.refinement-bar').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $('body').on('change', '[name=sort-order]', function (e) {
            e.preventDefault();

            $.spinner().start();
            $(this).trigger('search:sort', this.value);
            var url = this.value;
            var newFilterParams;
            if (url) {
                newFilterParams = urlUtilities.getUrlParamsArray(url);
            }
            $.ajax({
                url: url,
                data: { selectedUrl: url },
                method: 'GET',
                success: function (response) {
                    $('.product-grid').empty().html(response);
                    urlUtilities.updateUrlFilterParams(newFilterParams);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products lazy load
        var footerHeight = $('footer')[0].clientHeight;
        var showMoreBtnContainer = ($('.show-more')[0]) ? $('.show-more')[0].clientHeight : 0;
        var disableLoading = false;
        var pixelsUpToBtn = ((window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 769) ? 800 : 400;
        var discovermore = $('.discover-more').length > 0 ? ($('.discover-more')[0].clientHeight / 2) : 0;
        $(window).scroll(function () {
            var moreResultsBtnIsVisible = document.scrollingElement.scrollHeight - document.scrollingElement.scrollTop - footerHeight - showMoreBtnContainer - pixelsUpToBtn - discovermore <= document.scrollingElement.clientHeight;
            if (!disableLoading && $('.show-more')[0] && moreResultsBtnIsVisible) {
                var showMoreUrl = $('.show-more button').data('url');
                var sz = urlUtilities.getUrlParameter('sz', showMoreUrl);
                var start = urlUtilities.getUrlParameter('start', showMoreUrl);
                var szFinal = parseInt(sz, 10) + parseInt(start, 10);
                disableLoading = true;
                $.spinner().start();
                $.ajax({
                    url: showMoreUrl,
                    data: { selectedUrl: showMoreUrl },
                    method: 'GET',
                    success: function (response) {
                        $('.grid-footer').replaceWith(response);
                        updateSortOptions(response);
                        showSortOrder();
                        disableLoading = false;
                        urlUtilities.updatePageParam(szFinal);
                        $.spinner().stop();
                    },
                    error: function () {
                        disableLoading = false;
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $('.container').on(
            'click',
            '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .filter-bar button.reset',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger('search:filter', e);
                var url = $(this).data('href');
                var newFilterParams;
                if (url) {
                    newFilterParams = urlUtilities.getUrlParamsArray(url);
                }
                $.ajax({
                    url: url,
                    data: {
                        page: $('.grid-footer').data('page-number'),
                        selectedUrl: url
                    },
                    method: 'GET',
                    success: function (response) {
                        parseResults(response);
                        showFilter();
                        showSortOrder();
                        urlUtilities.updateUrlFilterParams(newFilterParams);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    showContentTab: function () {
        // Display content results from the search
        $('.container').on('click', '.content-search', function () {
            if ($('#content-search-results').html() === '') {
                getContent($(this), $('#content-search-results'));
            }
        });

        // Display the next page of content results from the search
        $('.container').on('click', '.show-more-content button', function () {
            getContent($(this), $('#content-search-results'));
            $('.show-more-content').remove();
        });
    },

    filtersInHeader: function () {
        fixHeader();

        $(window).scroll(function () {
            fixHeader();
        });

        $(window).resize(function () {
            var innerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (innerWidth < 992) {
                ($('.search-results .breadcrumb').hasClass('fixed-top')) ? $('.search-results .breadcrumb').removeClass('fixed-top') : '';
                ($('.search-results .filter-bar').hasClass('fixed-top')) ? $('.search-results .filter-bar').removeClass('fixed-top') : '';
                ($('.search-results .refinement-bar').hasClass('fixed-top')) ? $('.search-results .refinement-bar').removeClass('fixed-top') : '';
                ($('.search-results .grid-header').hasClass('fixed-top')) ? $('.search-results .grid-header').removeClass('fixed-top') : '';
                ($('.search-results .product-grid').hasClass('fixed-top')) ? $('.search-results .product-grid').removeClass('fixed-top') : '';
            }
        });
    }
};
